import { SVGProps } from "react";

const UIWMinus = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20" {...props}><path fill="#555" d="M0.7,10.4 C0.313400675,10.4 0,10.0865993 0,9.7 C0,9.31340068 0.313400675,9 0.7,9 L19.3055622,9 C19.6921615,9 20.0055622,9.31340068 20.0055622,9.7 C20.0055622,10.0865993 19.6921615,10.4 19.3055622,10.4 L0.7,10.4 Z" /></svg>;

export { UIWMinus };